'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const TrendChartInner = dynamic(() => import('./TrendChartInner'), { ssr: false });

export default function TrendChart() {
  return <TrendChartInner />;
}